import { render, staticRenderFns } from "./ItemPriceWithPrimitiveValue.vue?vue&type=template&id=717a3b15&scoped=true&"
import script from "./ItemPriceWithPrimitiveValue.vue?vue&type=script&lang=ts&"
export * from "./ItemPriceWithPrimitiveValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a3b15",
  null
  
)

export default component.exports